import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 2,
			width: 13,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 5.66666,
			width: 13,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 9.33332,
			width: 13,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 13,
			width: 13,
			height: 1,
			rx: .5,
			fill: "currentColor"
		})
	]
});
export default SvgListView;
